import * as stylex from '@stylexjs/stylex';

export const SIDEBAR_MIN_WIDTH = 256;
export const SIDEBAR_MAX_WIDTH = 512;
export const MAIN_CONTENT_MIN_WIDTH = 512;
export const PANEL_RESIZER_WIDTH = 12;

export const panelStyles = stylex.create({
  panels: { width: '100%', height: '100%', overflow: 'hidden' },
  redesignedPanels: { overflowX: 'auto' },
  sidebar: (width: number) => ({
    width,
    minWidth: SIDEBAR_MIN_WIDTH,
    maxWidth: `min(${SIDEBAR_MAX_WIDTH}px, calc(100% - ${MAIN_CONTENT_MIN_WIDTH + PANEL_RESIZER_WIDTH}px))`,
    flexShrink: 0,
  }),
  mainView: { minWidth: MAIN_CONTENT_MIN_WIDTH },
  resizer: { width: PANEL_RESIZER_WIDTH, flexShrink: 0 },
});
